// const PAGINATION_CLASS_LIST =
//   'bg-gray-100 dark:bg-zinc-700 text-default hover:bg-gray-200 hover:dark:bg-zinc-800 border-solid border-1 border-gray-100 dark:!border-none cursor-pointer rounded-[10px]'

export default defineAppConfig({
  ui: {
    disableFonts: true,
    colors: {
      primary: 'blue',
      neutral: 'neutral',
    },
    button: {
      slots: {
        base: 'rounded-[10px] px-5 text-[16px] font-medium cursor-pointer transition-all duration-200',
        leadingIcon: 'size-5 min-w-5',
        trailingIcon: 'size-5 min-w-5',
      },
      defaultVariants: {
        size: 'lg',
      },
      variants: {
        size: {
          sm: {
            base: 'rounded-[10px] px-4 text-[14px]',
          },
          md: {
            base: 'rounded-[10px] px-5 text-[16px]',
          },
          lg: {
            base: 'rounded-[10px] px-6 text-[16px]',
          },
        },
      },
    },
    input: {
      slots: {
        base: 'rounded-[10px] px-4 py-3 text-[16px] ring-0',
        leadingIcon: 'size-5 min-w-5',
        trailingIcon: 'size-5 min-w-5',
      },
    },
    select: {
      slots: {
        base: 'rounded-[10px] px-4 py-3 text-[16px]',
        content: 'z-[70]',
      },
    },
    inputMenu: {
      slots: {
        base: 'rounded-[10px] px-4 py-3 text-[16px]',
        content: 'z-[70]',
      },
    },
    selectMenu: {
      slots: {
        base: 'rounded-[10px] px-4 py-3 text-[16px]',
        input: 'p-2',
        content: 'z-[70] rounded-[10px]',
      },
      variants: {
        size: {
          lg: {
            label: 'p-3 text-xs gap-2',
            item: 'p-3 text-sm gap-2',
            empty: 'p-3 text-sm',
          },
        },
      },
      defaultVariants: {
        size: 'lg',
      },
    },
    modal: {
      slots: {
        overlay: 'z-[60]',
        content: 'z-[60] rounded-3xl',
        header: 'px-6 py-5',
        body: 'px-6 py-5',
        footer: 'px-6 py-5',
      },
    },
    slideover: {
      slots: {
        // content: 'rounded-l-3xl',
        header: 'sm:px-6 sm:py-5',
        body: 'sm:px-6 sm:py-5',
        footer: 'sm:px-6 sm:py-5',
      },
    },
    card: {
      slots: {
        root: 'rounded-2xl',
        header: 'px-6 py-5',
        body: 'px-6 py-5',
        footer: 'px-6 py-5',
      },
    },
    table: {
      slots: {
        root: 'rounded-2xl overflow-hidden',
        th: 'p-2 font-medium text-highlighted first:pl-4 last:pr-4',
        td: 'p-2 text-highlighted max-w-[300px] truncate first:pl-4 last:pr-4',
      },
    },
    pagination: {
      slots: {
        label: 'h-5',
        // item: '',
        // first: '',
        // prev: '',
        // next: '',
        // last: ''
      },
    },
    badge: {
      slots: {
        base: 'rounded-[10px]',
      },
    },
    checkbox: {
      slots: {
        base: 'rounded',
        wrapper: 'w-5',
      },
    },
    switch: {
      slots: {
        base: 'rounded-[10px]',
      },
    },
    textarea: {
      slots: {
        base: 'rounded-[10px] px-4 py-3 text-[16px]',
      },
    },
    formField: {
      slots: {
        label: 'text-sm font-medium',
        container: 'mt-1.5',
      },
    },
    tabs: {
      slots: {
        list: 'rounded-2xl p-1 gap-1',
        trigger: 'rounded-[10px] px-4 py-3 text-[15px] font-medium',
      },
    },
    popover: {
      slots: {
        content: 'z-[70] rounded-[10px]',
      },
    },
    tooltip: {
      slots: {
        content: 'z-[70] rounded-[10px] px-3 py-2 text-sm',
      },
    },
    dropdownMenu: {
      slots: {
        content: 'z-[70] rounded-[10px] p-1',
        item: 'rounded-[10px]',
      },
    },
  },
})
